import React from 'react';

import {
  LoadingOutlined
} from '@ant-design/icons';

import {
  Spin
} from 'antd';

import {
  useTranslation
} from 'react-i18next';

import {
  useAppDispatch
} from '../../hooks/useAppDispatch';
import {
  useAppSelector
} from '../../hooks/useAppSelector';

import {
  setActiveTool
} from '../../store/activeTool';
import {
  toggleVisibility
} from '../../store/drawer';

import BasicMapComponent from '../BasicMapComponent';
import MapToolbar from '../MapToolbar';
import SideDrawer from '../SideDrawer';

const LayerTree = React.lazy(() => import('../LayerTree'));
const FeatureInfo = React.lazy(() => import('../FeatureInfo'));

import './index.less';

export type MapPaneProps = {};

export const MapPane: React.FC<Partial<MapPaneProps>> = (): JSX.Element => {

  const isDrawerOpen = useAppSelector(state => state.drawer.visible);
  const activeTool = useAppSelector(state => state.activeTool);

  const dispatch = useAppDispatch();

  const {
    t
  } = useTranslation();

  const getSideDrawerContent = () => {
    switch (activeTool) {
      case 'feature-info':
        return <FeatureInfo />;
      case 'layer-tree':
        return <LayerTree />;
      default:
        break;
    }
  };

  const getSideDrawerTitle = () => {
    switch (activeTool) {
      case 'feature-info':
        return t('MapPane.featureInfoDrawerTitle');
      case 'layer-tree':
        return t('MapPane.layerTreeDrawerTitle');
      default:
        break;
    }
  };

  const onDrawerClose = () => {
    dispatch(toggleVisibility());
    dispatch(setActiveTool(null));
  };

  return (
    <>
      <BasicMapComponent>
        <MapToolbar />
      </BasicMapComponent>
      <SideDrawer
        title={getSideDrawerTitle()}
        onClose={onDrawerClose}
        open={isDrawerOpen}
      >
        <React.Suspense
          fallback={
            <Spin
              className="mappane-spin"
              indicator={
                <LoadingOutlined
                  spin={true}
                />
              }
            />
          }
        >
          {getSideDrawerContent()}
        </React.Suspense>
      </SideDrawer>
    </>
  );
};

export default MapPane;
